export const decodeBase64 = (data) => {
  try {
    console.log("Decoding base64")
    console.log("Data:", data)
    // Remove the "data:application/json;base64," prefix if it exists
    const base64Data = data.split(";base64,").pop()
    console.log("split and pop successful")
    const jsonString = atob(base64Data)
    console.log("atob successful")
    console.log("Decoded JSON string:", jsonString)
    return JSON.parse(jsonString)
  } catch (err) {
    console.error("Error decoding base64:", err)
    return null
  }
}
